module.exports = __webpack_public_path__ + "static/pro-banner11@2x-5cf34d79890927425d9716fea820ff5d.jpg";